import { InjectionToken } from '@angular/core';

/**
 * Injection token designed to collect the brand code from the response header.
 * Please look into the app-bootstrap README.
 */
export const APP_TENANT = new InjectionToken<string>('APP_TENANT');

/**
 * Injection token designed to collect the RQP stage on which the app is being executed.
 */
export const APP_STAGE = new InjectionToken<string>('APP_STAGE');

/**
 * Injection token designed to allow some extra logging during runtime via response headers.
 */
export const APP_DEBUG = new InjectionToken<boolean>('APP_DEBUG');
